import { AE_USE_CASES, USE_CASE, UseCase } from "@/constants";
import {
  Item,
  ItemMedia,
  ItemContent,
  ItemTitle,
  ItemDescription,
} from "@components/ui/item";
import { i18n } from "@lingui/core";
import OtherUseCase from "./other-use-case";

type UseCasesProps = {
  value: Array<UseCase | string>;
  onChange: (value: Array<UseCase | string>) => void;
  customUseCase?: string;
  onCustomUseCaseChange: (value?: string) => void;
};

export default function UseCases({
  value,
  onChange,
  customUseCase,
  onCustomUseCaseChange,
}: UseCasesProps) {
  return (
    <div className="grid 2xl:grid-cols-2 gap-4 max-w-lg 2xl:max-w-3xl mx-auto">
      {AE_USE_CASES.map((useCase) => {
        const isActive = value.includes(useCase.id);

        return (
          <Item
            className="text-left data-[active=true]:border-violet-500 data-[active=true]:bg-violet-50 group/use-case"
            data-active={isActive}
            variant="outline"
            key={useCase.id}
            asChild
          >
            <button
              type="button"
              data-testid={`use-case-${useCase.id}`}
              onClick={() => {
                onChange(
                  isActive
                    ? value.filter((id) => id !== useCase.id)
                    : [...value, useCase.id]
                );
              }}
            >
              <ItemMedia
                variant="icon"
                className="group-data-[active=true]/use-case:bg-violet-600 group-data-[active=true]/use-case:border-violet-600 group-data-[active=true]/use-case:text-white"
              >
                <useCase.icon />
              </ItemMedia>
              <ItemContent className="gap-0.5">
                <ItemTitle>{i18n._(useCase.title)}</ItemTitle>
                <ItemDescription>{i18n._(useCase.description)}</ItemDescription>
              </ItemContent>
            </button>
          </Item>
        );
      })}

      <OtherUseCase
        isActive={value.includes(USE_CASE.OTHER)}
        initialDescription={customUseCase}
        onClear={() => {
          onChange(value.filter((useCase) => useCase !== USE_CASE.OTHER));
          onCustomUseCaseChange(undefined);
        }}
        onAdd={(otherUseCase) => {
          if (!value.includes(USE_CASE.OTHER)) {
            onChange([...value, USE_CASE.OTHER]);
          }
          onCustomUseCaseChange(otherUseCase);
        }}
      />
    </div>
  );
}
